import { VildEncodingStatusType } from 'app/models/enums';

import { VildData } from './vilddata.model';
import { VildVersion } from './vildversion.model';

export class AlertcLinear {
  public id: number;
  public siterecordId: number;
  public alertcIndex: number;
  public vildVersion: VildVersion;
  public vildEncodingStatus: VildEncodingStatusType;
  public locationCountryCode: string;
  public directionCoded: string;
  public directionSense: boolean;
  public primaryVildLocation: VildData;
  public primaryOffsetDistance: number;
  public secondaryVildLocation: VildData;
  public secondaryOffsetDistance: number;
  public startLatitude: number;
  public startLongitude: number;
  public endLatitude: number;
  public endLongitude: number;
  public displayLatitude: number;
  public displayLongitude: number;
  public carriagewayStartpoint: string; // CarriagewayType
  public carriagewayEndpoint: string; // CarriagewayType
  public lengthAffected: number;
}



// WEBPACK FOOTER //
// ./src/app/models/alertclinear.model.ts